import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toastActions } from "@base-provider";
import { FileUploadWizard } from "@sf-fileUpload";
import PropTypes from "prop-types";
import {
  addDataset,
  getUploadedDatasetStatus,
} from "../../services/datasetService";
import { STATUS } from "../../constants/datasetStatus";
import { ACCEPTED_FILE_TYPES } from "../../constants/acceptedFileTypes";
import { useTranslation } from "react-i18next";

const FileUpload = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const finishHandler = () => {
    navigate(props.finishNavigationUrl);
    dispatch(toastActions.showSuccessMessage(t("fileUploadScreen.successMessage")));
  };
  const cancelHandler = () => {
    navigate(props.finishNavigationUrl);
  };

  const onBeginDatasetUpload = async (dataset) => {
    const addDataSetRes = await addDataset(dataset);
    return addDataSetRes;
  };

  const onEndDatasetUpload = async (transactionId) => {
    const result = await getUploadedDatasetStatus(transactionId);

    return {
      wait:
        result.data.status === STATUS.PENDING ||
        result.data.status === STATUS.LOADING,
      messages: result.data.validationErrors,
    };
  };

  return (
    <FileUploadWizard
      onBeginDatasetUpload={onBeginDatasetUpload}
      onEndDatasetUpload={onEndDatasetUpload}
      acceptedFileTypes={ACCEPTED_FILE_TYPES}
      name={props.name}
      entityName={props.entityName}
      onFinish={finishHandler}
      onCancel={cancelHandler}
    />
  );
};

FileUpload.defaultProps = {
  finishNavigationUrl: "/"
};

FileUpload.propTypes = {
  acceptedFileTypes: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  entityName: PropTypes.string,
  finishNavigationUrl: PropTypes.string
};

export default FileUpload;
